import React from "react";
import { connect } from "react-redux";
import cs from "classnames";

import mapDispatch from "~/misc/mapDispatch";
import DropDown from "~/components/common/DropDown";
import LabeledInput from "~/components/common/LabeledInput";
import { modalClose, modalChange } from "~/modules/modal/actions";
import * as modes from "~/modules/modal/modes";

import {
  getDistanceAction,
  getRateAction,
  setRateAction,
} from "../../state/action";

import descriptionImg from "../../../../../assets/posttruck/description.svg";
import changeImg from "../../../../../assets/posttruck/change.svg";
import questionmarkImg from "../../../../../assets/posttruck/questionmark.svg";
import unlockImg from "../../../../../assets/posttruck/unlock.svg";

import css from "./style.css";

const trailerTypes = ["Van", "Flatbed", "Reefer"];

class RateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      perRateLeft: true,
      trailerType: "Van",
      originData:
        this.props.context.origin && this.props.context.origin.placeValue,
      destinationData:
        this.props.context.destination &&
        this.props.context.destination.placeValue,
      distance: 0,
      perRate: this.props.context.rate ? this.props.context.rate : 0,
      totalPrice: 0,
      memberRate: 0,
      memberPrice: 0,
      showTooltip: false,
    };
  }
  componentWillMount() {
    if (this.hasAddress()) {
      this.getDistance();
      this.props.account.accountLevel > 3 && this.getRate();
    }
  }
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    if (
      this.props.account.accountLevel != nextProps.account.accountLevel &&
      nextProps.account.accountLevel > 3
    )
      this.getRate();
  }
  render() {
    const dropdownList = () => {
      return trailerTypes.map((item) => (
        <div
          className={css.trailerTypeItem}
          key={item}
          onClick={() => {
            this.calculateRate(item);
          }}
        >
          {item}
        </div>
      ));
    };

    const RateType = () => {
      return (
        <DropDown
          data-qa={`data-qa-ptModalTrailerType`}
          id="ptModalTrailerType"
          wrapClassName={css.simpleDropdown}
          allowKeyboard={true}
          trigger={
            <LabeledInput
              data-qa={"data-qa-input"}
              mediumInput
              value={this.state.trailerType}
              icon="plus"
              readOnly={true}
            />
          }
          content={dropdownList()}
        />
      );
    };
    return (
      <section className={css.rateModal}>
        <header className={css.rateHeader}>Set Your Rate</header>
        <main className={css.rateMain}>
          <div className={css.ratePanel}>
            <div className={css.rateDistance}>
              <span>Trip Distance:</span>
              <span>
                <span className={css.rateDistanceSum}>
                  {this.state.distance}
                </span>
                mile
              </span>
            </div>
            <div className={css.rateCalculate}>
              <div className={css.rateCalculateLeft}>
                {this.state.perRateLeft ? (
                  <div className={css.showContent}>
                    <div className={css.title}>Rate Per Mile</div>
                    <div className={css.rateInput}>
                      <span className={css.rateCalculatePrefix}>$</span>
                      <input
                        type="text"
                        value={this.state.perRate}
                        onChange={(e) => this.numberChange("rate", e)}
                        readOnly={!this.state.perRateLeft}
                        // onBlur={(e) => this.inputBlur("rate", e)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className={css.showContent}>
                    <div className={css.title}>Totle Price</div>
                    <div className={css.rateInput}>
                      <span className={css.rateCalculatePrefix}>$</span>
                      <input
                        type="text"
                        value={this.state.totalPrice}
                        onFocus={() => this.checkAddress()}
                        onChange={(e) => this.numberChange("price", e)}
                        readOnly={this.state.perRateLeft}
                      />
                    </div>
                  </div>
                )}
              </div>
              <button
                className={css.rateCalculateBtn}
                onClick={() => this.changeCalculate()}
              >
                {changeImg()}
              </button>
              <div className={css.rateCalculateRight}>
                {this.state.perRateLeft ? (
                  <div className={css.showContent}>
                    <div className={css.title}>Totle Price</div>
                    <div className={css.rateInput}>
                      <span className={css.rateCalculatePrefix}>$</span>
                      <input
                        type="text"
                        value={this.state.totalPrice}
                        onChange={(e) => this.numberChange("price", e)}
                        readOnly={this.state.perRateLeft}
                      />
                    </div>
                  </div>
                ) : (
                  <div className={css.showContent}>
                    <div className={css.title}>Rate Per Mile</div>
                    <div className={css.rateInput}>
                      <span className={css.rateCalculatePrefix}>$</span>
                      <input
                        type="text"
                        value={this.state.perRate}
                        onChange={(e) => this.numberChange("rate", e)}
                        readOnly={!this.state.perRateLeft}
                      />
                    </div>
                  </div>
                )}
                <div className={css.rateCalculateMask}>
                  <span
                    onClick={() => this.toggleToolTip("click")}
                    // onMouseLeave={() => this.toggleToolTip("leave")}
                  >
                    {descriptionImg()}
                  </span>
                  {this.state.showTooltip && (
                    <div className={css.tooltip}>
                      Rate per mile is calculated by using the total price
                      entered divided by the trip distance.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={css.rateHelp}>
            <div className={css.helpTitle}>
              {questionmarkImg()}
              <span>Need help setting your rate?</span>
            </div>
            <div className={css.helpPanel}>
              <div className={css.helpDropdown}>
                <RateType />
              </div>
              <div className={css.helpResult}>
                {this.props.account.accountLevel < 3 ? (
                  <div className={css.rate}>
                    <span>Rate:</span>
                    <span>$*.**</span>
                  </div>
                ) : (
                  <div className={css.rate}>
                    <span>Rate:</span>
                    <span>${this.state.memberRate}</span>
                  </div>
                )}
                {this.props.account.accountLevel < 3 ? (
                  <div className={css.extPrice}>
                    <span>Est Price:</span>
                    <span>$****.**</span>
                  </div>
                ) : (
                  <div className={css.extPrice}>
                    <span>Est Price:</span>
                    <span>${this.state.memberPrice}</span>
                  </div>
                )}
                {this.props.account.accountLevel < 3 && (
                  <div className={css.helpResultMask}>
                    <button
                      onClick={() => this.props.upgradeAccount()}
                      className={css.upgradeAccount}
                    >
                      {unlockImg()}Unlock
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
        <footer className={css.rateFooter}>
          <button className={css.footerBtn} onClick={() => this.rateConfirm()}>
            Set Rate
          </button>
        </footer>
      </section>
    );
  }
  hasAddress() {
    return (
      this.state.originData &&
      this.state.originData.lat &&
      this.state.originData.lng &&
      this.state.destinationData &&
      this.state.destinationData.lat &&
      this.state.destinationData.lng
    );
  }
  rateConfirm() {
    this.checkAddress();
    if (!this.hasAddress() && !this.state.perRateLeft) return;
    this.props.setRate(this.state.perRate);
    this.props.closeProp();
  }
  checkAddress() {
    if (!this.hasAddress() && !this.state.perRateLeft) {
      this.props.context.toggleFunc();
    }
  }
  toggleToolTip(type) {
    if (type === "leave") this.setState({ showTooltip: false });
    if (type === "click")
      this.setState({ showTooltip: !this.state.showTooltip });
  }
  getDistance() {
    this.props
      .getDistance({
        fromLng: this.state.originData.lng,
        fromLat: this.state.originData.lat,
        toLng: this.state.destinationData.lng,
        toLat: this.state.destinationData.lat,
      })
      .then((res) => {
        if (!res) return;
        this.setState({ distance: res.data });
        this.calculate("rate", this.state.perRate);
      });
  }
  getRate(type) {
    const { originData, destinationData, trailerType } = this.state;
    if (
      this.props.account.accountLevel < 3 ||
      !originData ||
      !originData.name ||
      !destinationData ||
      !destinationData.name
    )
      return;
    this.props
      .getRate({
        dropOff: {
          lng: destinationData.lng,
          lat: destinationData.lat,
          address: destinationData.name,
        },
        equipment: (type || trailerType).toLowerCase(),
        interval: "ONE",
        pickUp: {
          lng: originData.lng,
          lat: originData.lat,
          address: originData.name,
        },
      })
      .then((res) => {
        if (!res) return;
        this.setState({
          memberRate: res.data.avgRate ? res.data.avgRate : "--",
          memberPrice: res.data.revenue ? res.data.revenue : "--",
        });
      });
  }
  numberChange(type, e) {
    const inputArray = e.target.value.match(
      /([1-9]\d*\.?\d{0,2})|(0\.\d{0,2}}[1-9])/g
    );
    let inputVal = inputArray && inputArray[0] ? inputArray[0] : 0;
    this.calculate(type, inputVal);
  }
  calculate(type, inputVal) {
    let total = 0;
    let perRate = 0;
    if (type === "rate") {
      perRate = inputVal;
      total = (this.state.distance * inputVal).toFixed(2);
    } else {
      perRate =
        inputVal && this.state.distance
          ? (inputVal / this.state.distance).toFixed(2)
          : 0;
      total = inputVal;
    }
    this.setState({ perRate: perRate, totalPrice: total });
  }
  changeCalculate() {
    this.setState({
      perRateLeft: !this.state.perRateLeft,
    });
  }
  calculateRate(type) {
    if (type === this.state.trailerType) return;
    this.setState({ trailerType: type });
    this.getRate(type);
  }
}

export default connect(
  (state, ownProps) => {
    return {
      account: state.account,
      rate: state.postTruck.rate,
      ...ownProps,
    };
  },
  mapDispatch({
    getDistance: (props, data) => getDistanceAction(data),
    upgradeAccount: (props) =>
      modalChange("pop", {
        source: "post_truck",
        type: "pop_upgrade_to_premium",
      }),
    closeProp: () => modalClose(modes.POSTTRUCK_RATE),
    getRate: (props, data) => getRateAction(data),
    setRate: (props, rate) => setRateAction(rate),
  })
)(RateModal);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/RateModal/index.js